import { withDirectModifiedFields } from 'utils/pendingChanges';

export class FinancialInfoApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSummary({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/financialInformation/summary`),
    );
  }

  async getAssets({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/assets/view`),
    );
  }

  async getLiabilities({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/liabilities/view`),
    );
  }

  async getIncomes({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/incomes/view`),
    );
  }

  async getProperties({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/properties/view`),
    );
  }
}
